import React from "react";
import Button from "Components/button/Button";
import TranslatedString from "Components/TranslatedString";
import { t } from "i18next";
import XDate from "xdate";
import PropTypes from "prop-types";
import Divider from "Components/divider/Divider";
import DayPicker from "Components/dayPicker/DayPicker";
import Checkbox from "Components/checkbox/Checkbox";
import WarningBanner from "Components/warningBanner/WarningBanner";
import cx from "classnames";

const ContextTypes = {
  getLoggedUser: PropTypes.func,
};

class Expiration extends React.Component {
  constructor(props) {
    super(props);
    this.goToNextStep = this.goToNextStep.bind(this);
    this.updateStartDate = this.updateStartDate.bind(this);
    this.updateExpiration = this.updateExpiration.bind(this);

    let date = new XDate();
    this.state = {
      tomorrow: date.addDays(1).toDate(),
    };
  }

  goToNextStep(e) {
    e.preventDefault();
    this.props.goToStep(3);
  }

  updateStartDate(val) {
    if (val.visualization_start && this.props.formData.visualization_end) {
      let start = new XDate(val.visualization_start);
      let end = new XDate(this.props.formData.visualization_end);
      if (start.diffDays(end) < 0) {
        val.visualization_end = undefined;
      }
    }

    this.props.setFormFieldValue(val);
  }

  updateExpiration(val) {
    if (val.expiration && this.props.formData.visualization_end) {
      let expiration = new XDate(val.expiration);
      let end = new XDate(this.props.formData.visualization_end);
      if (expiration.diffDays(end) > 0) {
        val.visualization_end = undefined;
      }
    }

    this.props.setFormFieldValue(val);
  }

  render() {
    const { formData, setFormFieldValue, isFormLoading, formErrors } = this.props;
    const { tomorrow } = this.state;

    return (
      <div className="formsPage">
        {this.props.stepper}

        <div className={cx("sectionTitle", "titleFP")}>{t("delegate.add.title.step2")}</div>

        <div className="wrapScrollFP">
          <div className="infoFP">
            <div className="sectionDesc">
              <TranslatedString>delegate.add.desc.step2</TranslatedString>
            </div>
            <Button className="btnDocsFP" docsKey="delegates_add" color="docs" sizeSmall>
              button.docs
            </Button>
          </div>

          <form className="wrapFormsFP" method="post" onSubmit={this.goToNextStep}>
            <div className="formsFP">
              <Checkbox
                className="inputFull2"
                label={t("input.label.authorization.noExpiration")}
                name="no_expiration"
                checked={formData.no_expiration}
                onChange={setFormFieldValue}
              />

              <DayPicker
                className={cx("inputFull2", "inputAddMargin")}
                label={t("input.label.authorization.expiration")}
                name="expiration"
                value={formData.expiration}
                minDate={tomorrow}
                onChange={this.updateExpiration}
                disabled={formData.no_expiration}
              />

              <Checkbox
                className="inputFull2"
                label={t("input.label.visualization.always")}
                name="always"
                checked={formData.always}
                onChange={setFormFieldValue}
              />

              <DayPicker
                label={t("input.label.visualization.start")}
                name="visualization_start"
                value={formData.visualization_start}
                maxDate={formData.expiration}
                onChange={this.updateStartDate}
                errors={formErrors.visualization_start}
                disabled={formData.always}
              />

              <DayPicker
                label={t("input.label.visualization.end")}
                name="visualization_end"
                value={formData.visualization_end}
                minDate={formData.visualization_start}
                maxDate={formData.expiration}
                onChange={setFormFieldValue}
                errors={formErrors.visualization_end}
                disabled={formData.always}
              />
            </div>

            {formErrors.onForm && (
              <div className="warningMsgFP">
                <WarningBanner color="red" msg={formErrors.onForm} />
              </div>
            )}

            <div className="footerFP">
              <Button color="text" type="button" onClick={this.props.backToList}>
                button.cancel
              </Button>
              <Button color="accent" type="submit" loading={isFormLoading}>
                button.continue
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

Expiration.contextTypes = ContextTypes;
export default Expiration;
